import React, { useEffect } from 'react'
import {
    // BrowserRouter as Router, 
    HashRouter as Router,
    Switch, Route, Redirect,
    useParams, useLocation
} from 'react-router-dom'
import {
    useWindowWidth, useWindowHeight
} from '@react-hook/window-size'
import { applyMiddleware, createStore } from 'redux'
import { Provider, useDispatch } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import reducer from './reduxes/reducers/reducer'
import rootSaga from './reduxes/sagas/saga'

import './App.css'
import "react-responsive-carousel/lib/styles/carousel.min.css";

import Home from './views/home'
import ShowRoom from './views/showRoomPage'
import CarSimulatePage from './views/carSimulatePage'
import ErrorBrowser from './views/errorBrowser'

import { createPrefixOfUrl } from './common'

const sagaMiddleware = createSagaMiddleware()
const store = createStore(reducer, applyMiddleware(sagaMiddleware))

sagaMiddleware.run(rootSaga)

const RedirectWithCarIdPage = () => {
    const { carId } = useParams()
    const location = useLocation()

    if (location.state !== undefined) {
        return (
            <Redirect to={`${createPrefixOfUrl()}/${carId}/${location.state.inOrEx}`} />
        )
    } else {
        return (
            <Redirect to={`${createPrefixOfUrl()}/${carId}/exterior`} />
        )
    }

}

const CarSimulatePageWrapper = () => {
    const { inOrEx } = useParams()
    return (
        <>
            {(inOrEx === 'interior' || inOrEx === 'exterior') ? <CarSimulatePage /> : <Redirect to={`${createPrefixOfUrl()}/home`} />}
        </>
    )
}

const RouterWrapper = () => {
    const dispatch = useDispatch()
    const windowWidth = useWindowWidth()
    const windowHeight = useWindowHeight()

    useEffect(() => {
        dispatch({ type: "INIT_LANGUAGE" })
        dispatch({ type: "INIT_COUNTRY" })
    }, [dispatch])

    useEffect(() => {
        window.localStorage.setItem('window_width', windowWidth)
        window.localStorage.setItem('window_height', windowHeight)
    }, [windowWidth, windowHeight])

    return (
        <Router>
            <Switch>
                <Route path={`${createPrefixOfUrl()}/home`} exact>
                    <Home />
                </Route>
                <Route path={`${createPrefixOfUrl()}/showroom`} exact>
                    <ShowRoom />
                </Route>
                <Route path={`${createPrefixOfUrl()}/error-browser`} exact>
                    <ErrorBrowser />
                </Route>
                <Route path={`${createPrefixOfUrl()}/:carId`} exact>
                    <RedirectWithCarIdPage />
                </Route>
                <Route path={`${createPrefixOfUrl()}/:carId/:inOrEx`} exact>
                    <CarSimulatePageWrapper />
                </Route>

                <Route>
                    <Redirect to={`${createPrefixOfUrl()}/home`} />
                </Route>
            </Switch>
        </Router>
    )
}

const App = () => {
    return (
        <Provider store={store}>
            <RouterWrapper />
        </Provider>
    )
}

export default App